import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { LoadingComponent } from "../components/LoadingComponent";
import { useProfile } from "../components/ProfileContext";
import { Inspection } from "../models/Inspection";
import { InspectionPage } from "./InspectionPage";

export function SharedInspectionPage(props) {
	let [profile] = useProfile();
	let [isLoading, setIsLoading] = useState(true);
	let params = useParams();

	console.log(profile);
	useEffect(async () => {
		if(isLoading) {
			try {
				await Inspection.loadInspection(profile, params.inspectionId, params.sharingCode);
				setIsLoading(false);
			} catch(err) {
				alert("Error loading inspection: " + err);
			}
		}	
	});


	if(isLoading) {
		return <LoadingComponent />
	}

	// Same params?
	return <InspectionPage />;
}